import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE, INSTAGRAM_POSTS } from "../data/site";

export const InstagramFeed = () => (
  <section id="instagram" className="bg-[#FFEFDF] py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Reveal><span className="overline">Follow along</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl mt-4 text-[#20301A]">Moments from the studio</h2>
            <p className="text-[#55703F] mt-3 max-w-md">A little everyday warmth — reflections, the space, and gentle reminders over on Instagram.</p>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <a data-testid="instagram-follow-cta" href={SITE.instagram} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#3A7D32] text-[#F2F8E8] px-6 py-3 text-sm hover:bg-[#20301A] transition-colors">
            <Instagram size={16} /> Follow {SITE.instagramHandle}
          </a>
        </Reveal>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 mt-10" data-testid="instagram-grid">
        {INSTAGRAM_POSTS.map((p, i) => (
          <Reveal key={p.src} delay={0.05 * i}>
            <a href={SITE.instagram} target="_blank" rel="noreferrer" data-testid={`instagram-post-${i}`}
              className="group relative block overflow-hidden rounded-2xl aspect-square">
              <img src={p.src} alt={p.alt} loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-[#20301A]/0 group-hover:bg-[#20301A]/45 transition-colors duration-300 flex items-end p-4">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-[#F2F8E8] text-xs flex items-center gap-1.5">
                  <Instagram size={13} /> {p.caption} <ArrowUpRight size={13} />
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
